"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Super/SuperOrganizationsScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _uploadStandaloneFile = require('web/services/uploadStandaloneFile');
var _alert = require('shared/actions/alert'); var _alert2 = _interopRequireDefault(_alert);
var _log = require('shared/log');
var _features = require('shared/enum/features'); var _features2 = _interopRequireDefault(_features);
var _alertReducer = require('shared/reducers/alertReducer');
var _useSearchQuery = require('shared/hooks/useSearchQuery');


var _Form = require('web/components/Form');
var _SuperTableTR = require('web/components/Super/SuperTableTR'); var _SuperTableTR2 = _interopRequireDefault(_SuperTableTR);


const OrgResult = ({ org }) => {
  return (
    _react2.default.createElement(_SuperTableTR2.default, { to: `/super/orgs/${org.OrgKey}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
      , _react2.default.createElement('td', { className: "uuid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}, org.OrgKey)
      , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}, org.Name)
      , _react2.default.createElement('td', { className: "numeric", __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}, org.NumberOfMembers)
      , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}, org.Verified ? 'yes' : 'no')
      , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}, org.EnabledFeatures.includes(_features2.default.ADVANCED_SEARCH) ? 'yes' : 'no')
    )
  )
}

const SuperOrganizationsScreen = () => {
  const [results, setResults] = _react.useState([])
  const [queryValue, setQueryValue] = _react.useState.call(void 0, "")
  const bounceTimeout = _react.useRef(undefined)
  const orgList = _react.useRef(undefined)

  const queryChange = _react.useCallback.call(void 0, (query) => {
    setQueryValue(query)
    clearTimeout(bounceTimeout.current)
    bounceTimeout.current = setTimeout(() => {
      _client2.default.send('SuperSearchOrgs', { Query: _useSearchQuery.sanitizeSearchQuery.call(void 0, query), limit: 50 })
        .then((res) => {
          setResults(Object.values(res))
        })
        .catch(_log.log.error)
    }, 300)
  }, [])

  _react.useEffect.call(void 0, () => {
    queryChange("")
    // A pending search no longer fires after the screen closes.
    return () => clearTimeout(bounceTimeout.current)
  }, [queryChange])

  const updateOrgList = (evt) => {
    orgList.current = _optionalChain([evt, 'access', _ => _.target, 'access', _2 => _2.files, 'optionalAccess', _3 => _3[0]])
  }

  const bulkCreate = (evt) => {
    evt.preventDefault()
    _log.log.info(orgList.current)
    // A missing file still goes to /upload_file, which rejects it, as before.
    _uploadStandaloneFile.uploadStandaloneFile.call(void 0, orgList.current)
      .then((Metadata) => {
        _client2.default.send('SuperBulkCreateOrgs', {
          FileKey: Metadata.FileKey,
        }).then(() => {
          _alert2.default.pushAlert("Success", "Successfully created orgs", _alertReducer.AlertTypes.SUCCESS)
        }).catch(_log.log.error)
      })
  }

  const rows = results.map((org) => _react2.default.createElement(OrgResult, { org: org, key: org.OrgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}} ))

  return (
    _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
      , _react2.default.createElement('div', { className: "super--search-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
        , _react2.default.createElement(_Form.TextInput, {
          placeholder: "Search for orgs..."  ,
          wrapperClassName: "super--search-bar",
          onChange: e => queryChange(e.target.value),
          value: queryValue, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
        )
      )
      , _react2.default.createElement('table', { className: "super--table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
        , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
          , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}, "Org Key" )
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}, "Name")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}, "Members")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}, "Verified")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}, "Paid")
          )
        )
        , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
          , rows
        )
      )
      , _react2.default.createElement('form', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}
        , _react2.default.createElement('input', { type: "file", id: "orgList", onChange: updateOrgList, __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}} )
        , _react2.default.createElement('button', { onClick: bulkCreate, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}, "Bulk Create Orgs"  )
      )
    )
  )
}

exports. default = SuperOrganizationsScreen
